import styles from './analytics.module.css';

const W = 240;
const H = 64;

const GRAN_NOUN = { day: 'day', month: 'month', year: 'year' };

const labelFor = (iso, granularity) => {
    const d = new Date(iso);
    const opts =
        granularity === 'year' ? { year: 'numeric' } : granularity === 'month' ? { month: 'short', year: 'numeric' } : { day: 'numeric', month: 'short' };
    return d.toLocaleDateString('en-GB', { ...opts, timeZone: 'UTC' });
};

/** Compact bar (or cumulative line) chart; the aria-label carries every value as text. */
const MiniChart = ({ title, buckets, values, granularity, kind = 'bars' }) => {
    const max = Math.max(...values, 1);
    const slot = W / values.length;
    const label = `${title} per ${GRAN_NOUN[granularity]}: ${values.map((v, i) => `${labelFor(buckets[i], granularity)} ${v}`).join(', ')}`;
    return (
        <svg className={styles.chart} viewBox={`0 0 ${W} ${H}`} role="img" aria-label={label} preserveAspectRatio="none">
            {kind === 'line' ? (
                <polyline
                    fill="none"
                    stroke="var(--blue-700)"
                    strokeWidth="2"
                    points={values.map((v, i) => `${i * slot + slot / 2},${H - 2 - (v / max) * (H - 6)}`).join(' ')}
                />
            ) : (
                values.map((v, i) => {
                    const h = (v / max) * (H - 4);
                    return <rect key={buckets[i]} x={i * slot + slot * 0.15} y={H - 2 - h} width={slot * 0.7} height={h} rx="1.5" fill="var(--blue-700)" />;
                })
            )}
        </svg>
    );
};

export default MiniChart;
